module.exports = __webpack_public_path__ + "img/icon_pdf_statement@3x.a01dd359.png";